import React from "react";

const AvatarPlaceholder: React.FC = () => {
  return (
    <svg
      width={80}
      height={80}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={40} cy={40} r={40} fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31 31C31 26.0294 35.0294 22 40 22C44.9706 22 49 26.0294 49 31C49 35.9706 44.9706 40 40 40C35.0294 40 31 35.9706 31 31ZM32.1089 44.7625C33.4659 44.4656 34.8416 44.2672 36.2026 44.1707C38.7292 43.9431 41.2704 43.9431 43.797 44.1707L44.6037 44.2404C45.7071 44.3515 46.8027 44.5254 47.8809 44.7604C50.629 45.3385 52.6246 46.3641 53.5079 48.2663C54.1641 49.6816 54.1641 51.3246 53.5076 52.7405C52.622 54.6475 50.6008 55.6816 47.9014 56.2254L47.0836 56.3988C45.9904 56.6131 44.8881 56.7593 43.7932 56.8358C41.7385 57.0144 39.6742 57.047 37.683 56.9351C37.4635 56.9351 37.3162 56.9344 37.1864 56.9313L36.9339 56.9216C36.627 56.9056 36.3458 56.8728 36.2278 56.8375C34.8425 56.7413 33.4664 56.5366 32.1462 56.2324L31.6984 56.137C29.1987 55.5698 27.3474 54.5465 26.4911 52.7384C26.1668 52.0368 25.999 51.2699 26 50.5001C25.9972 49.7246 26.1663 48.9587 26.5027 48.2433C27.3945 46.4142 29.4898 45.3135 32.1089 44.7625Z"
        fill="#EAEAEA"
      />
    </svg>
  );
};

export default AvatarPlaceholder;
